import { useEffect, useState } from "react";

export function decideTime(num) {
  let d = Math.floor(num / 1440); // 60*24
  let h = Math.floor((num - d * 1440) / 60);
  let m = Math.round(num % 60);
  if (d > 0) {
    if (h === 0) {
      return d + " h" + m + " m";
    }
    if (m === 0) {
      return d + " d " + h + " h ";
    } else {
      return d + " d " + h + " h " + m + " m";
    }
  } else {
    if (h === 0) {
      return m + " m";
    }
    if (m === 0) {
      return h + " h ";
    } else {
      return h + " h " + m + "m";
    }
  }
}
export const convertToForm = (parameters) => {
  let formData = new FormData();
  for (let name in parameters) {
    formData.append(name, parameters[name] ? parameters[name] : "");
  }
  return formData;
};
export const formatText = (text) => {
  if (!text) {
    return;
  }
  const decodedText = text?.replace(/&#10;/g, "\n"); // Replace encoded newlines
  const formattedText = decodedText.split("  ").map((line, index) => (
    <p key={index}>
      {line}
      {index < decodedText.split("  ").length - 1 && (
        <>
          <br /> <br />
        </>
      )}
    </p>
  ));
  return formattedText;
};

export const copyToClipboard = async (htmlElement) => {
  try {
    const divElement = document.createElement("div");
    divElement.innerHTML = htmlElement;
    const text = divElement.innerText || divElement.textContent;
    await navigator.clipboard.writeText(text);
  } catch (err) {
    //   setMessage("Failed to copy text.");
    console.error("Error copying text: ", err);
  }
};

export function isHTML(val) {
  const div = document.createElement("div");
  div.innerHTML = val;

  // If the input contains HTML tags, innerHTML will differ from textContent
  return div.innerHTML !== div.textContent;
}
export const isIOS = () => {
  return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
};
export function useIsMobile() {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return isMobile;
}

export const isAccessFeature = (user) => {
  if (user?.role === "Mentor") {
    return {
      plan_active: true,
      new_plan_active:true,
      code_active: true,
    };
  }
  
  return {
    plan_active:
      (user?.pricing_plan && user?.pricing_plan !== 4) ||
      (user?.affiliate_active && user?.pricing_plan),
    new_plan_active: (user?.pricing_plan && user?.pricing_plan !== 4) || user?.affiliate_active,
    code_active:
      (user?.pricing_plan && user?.pricing_plan !== 4) || (user?.affiliate_code && user?.pricing_plan),
  };
};
